<app-header [text]="'MOT.VACATIONS_REQUEST_MENU_LINK' | translate" [scrollArea]="myContent"></app-header>

<app-content #myContent>
  <div class="grid">
    <div class="row">
      <div class="col" size="12" size-md="8" offset-md="2">
        <div class="content">
          <app-title-section [text]="'MOT.VACATIONS_REQUEST_MENU_LINK' | translate"></app-title-section>
        </div>
      </div>
    </div>
    <app-spinner [showText]="true" *ngIf="loadingData"></app-spinner>
    <div class="grid" [class.grid-fixed]="gridFixedStyles">
      <div class="row" *ngIf="!loadingData">
        <div class="col" size="12" size-md="8" offset-md="2">
          <app-mot-manage-vacations
            [base]="this"
            (manageProposal)="onCreateProposal($event)"
            *ngIf="!isMomoUser; else momo"></app-mot-manage-vacations>

          <ng-template #momo>
            <app-momo-manage-vacations
              [base]="this"
              (createProposal)="onCreateProposal($event)"></app-momo-manage-vacations>
          </ng-template>

          <ng-container *ngIf="serverError">
            <app-no-results [isError]="serverError"></app-no-results>
          </ng-container>

          <ng-container *ngIf="sectionMaintenance">
            <app-section-maintenance></app-section-maintenance>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</app-content>
